import { defineStore } from "pinia";
import nuxtStorage from "nuxt-storage";
// import { useURLs } from "~/constants/api.urls";


export const useUtilityStore = defineStore("utility", () => {
  
  const newsLetter = ref();
  const getI18n = () => {
    try {
      return useNuxtApp()?.$i18n || null;
    } catch {
      return null;
    }
  };

  const t = (key, params) => {
    if (!key) return "";
    const i18n = getI18n();
    if (i18n && typeof i18n.t === "function") {
      return i18n.t(key, params);
    }
    return String(key);
  };

  const getLocale = () => {
    const i18n = getI18n();
    if (!i18n) return "en";
    const locale = i18n.locale;
    if (locale && typeof locale === "object" && "value" in locale) return locale.value;
    return locale || "en";
  };

  const setLocale = (language) => {
    const i18n = getI18n();
    if (!i18n) return;

    if (typeof i18n.setLocale === "function") {
      i18n.setLocale(language);
      return;
    }

    if (i18n.locale && typeof i18n.locale === "object" && "value" in i18n.locale) {
      i18n.locale.value = language;
      return;
    }

    i18n.locale = language;
  };

  const selectedLocale = ref(getLocale());
  const countryList = ref([]);
  const countryListDropDown = ref([]);
  const languageMap = ref({
    fr: "fr_BE",
    en: "en_GB",
    de: "de_DE",
    nl: "nl_BE",
    es: "es_ES",
    sv: "sv_SE",
    it: "it_IT",
    pl: "pl_PL",
  });
  const selectedLanguage = useState(
    "selected-lang",
    () => languageMap.value[getLocale()] || languageMap.value.en
  ); //ref("en");

  // products list css state
  const gridListType = ref("large");
  const SetGridType = (value) => {
    gridListType.value = value;
  };

  const setLanguage = (language) => {
    selectedLanguage.value = languageMap.value[language];
    selectedLocale.value = language;
    localStorage?.setItem("selectedLanguage", language);
    nuxtStorage.localStorage.setData("selectedLanguage", language, 100, "y");
    nuxtStorage.localStorage.setData(
      "selectedLocale",
      selectedLocale.value,
      100,
      "y"
    );

    setLocale(language);
    // locale.value = selectedLanguage.value.split("_")[0];
  };
  const downloadPdfDoc = async ({ id, docType, docNumber }) => {
    const url = `${useCldURLs[CLD_ENV].utility.download_pdf}?id=${id}&docType=${docType}&docNumber=${docNumber}`;
    // const token = useCookie('authToken').value;
    // if (!token) {
    //   return;
    // }
    const { data } = await useFetchApi(
      url,
      {
        method: "GET",
        headers: {
          Accept: "application/pdf",
        },
      },
      true
    );
    if (!data.value) {
      useNuxtApp().$showToast({
        msg: t("ERROR_DOWNLOAD"),
        type: "info",
      });
      return;
    }
    const downloadUrl = window.URL.createObjectURL(data.value);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", `${docType}_${docNumber}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  //Accounts Aging Summary Pdf download
const downloadPdfAccount = async ({ id, docType, docNumber }) => {
  const url = `${useCldURLs[CLD_ENV].utility.download_accounts_pdf}?id=${id}&docType=${docType}&docNumber=${docNumber}`;
  
  try {
    // Create AbortController for timeout (30 seconds)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);

    const { data } = await useFetchApi(
      url,
      {
        method: "GET",
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
        },
        signal: controller.signal,
      },
      true
    );

    clearTimeout(timeoutId);

    if (!data.value) {
      useNuxtApp().$showToast({
        msg: t("ERROR_DOWNLOAD"),
        type: "info",
      });
      return;
    }

    //  data.value BLOB
    const blob = new Blob([data.value], { type: "application/pdf" });
    const downloadUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `${docType}_${docNumber}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(downloadUrl);

    useNuxtApp().$showToast({
      msg: t('download_initiated'),
      type: "success",
    });
  } catch (error) {
    if (error.name === 'AbortError') {
      useNuxtApp().$showToast({
        msg: t('DOWNLOAD_TIMEOUT') || 'Download timed out. Please try again.',
        type: "error",
      });
    } else {
      console.error('Download error:', error);
      useNuxtApp().$showToast({
        msg: t("ERROR_DOWNLOAD"),
        type: "error",
      });
    }
  }
};


  // news letter registration
  const createContactCrm = async ({ firstName, lastName, email }) => {
    const url = useURLs[NODE_ENV].CRM_CREATE_CONTACT;
    const payload = JSON.stringify({ firstName, lastName, email });
    const { data } = await useFetch(url, {
      key: `${payload}`,
      method: "POST",
      body: payload,
      headers: {
        client_id: useURLs[NODE_ENV].CLIENT_ID,
        client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
        "Content-Type": "application/json",
      },
      retry: 2,
    });

    if (data.value && data.value.contact) {
      newsLetter.value = data.value.contact;
    } else {
      newsLetter.value = false;
    }
  };
  const downloadImages = async (images, id) => {
    try {
      const imagesPath = images.map(
        (image) => `https://assets.cld.be/cdn-cgi/image/quality=100/${image}`
      );
      const url = useURLs[NODE_ENV].IMAGE_FILE;

      const response = await $fetch(url, {
        method: "POST",
        body: {
          images: imagesPath,
        },
        responseType: "blob",
      });

      // const { data } = await useFetch(url, {
      //   key: id,
      //   method: "POST",
      //   body: {
      //     images: imagesPath,
      //   },
      //   headers: {
      //     client_id: useURLs[NODE_ENV].CLIENT_ID,
      //     client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      //     "Content-Type": "application/json",
      //   },
      //   retry: 2,
      // });

      const objectUrl = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = objectUrl;
      link.setAttribute("download", `${id}_images.zip`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      return;
    }
  };

  const getCountries = async () => {
    getRedis("COUNTRIES").then((data) => {
      try {
        const _countrylist = JSON.parse(data);
        if (_countrylist && _countrylist?.length) {
          countryListDropDown.value = _countrylist;
          return;
        }
      } catch (error) {
        console.error("error getting countries from cache", error);
      }
    });
    const url = useCldURLs[CLD_ENV].utility.countries;
    const { data } = await useFetch(url, {
      method: "GET",
    });

    if (data.value?.length) {
      countryListDropDown.value = data.value.map((country) => ({
        Iso: country.iso,
        Name: country.name,
        isEU: country.eucountry,
      }));
      setRedis({
        key: "COUNTRIES",
        value: JSON.stringify(countryListDropDown.value),
      });
    }
  };
  return {
    selectedLanguage,
    selectedLocale,
    languageMap,
    setLanguage,
    downloadPdfDoc,
    downloadPdfAccount,
    createContactCrm,
    newsLetter,
    downloadImages,
    gridListType,
    SetGridType,
    getCountries,
    countryList,
    countryListDropDown,
  };
});
